/**
 * Schedule RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import {
  ListSchedulesRequestSchema,
  ListSchedulesResponseSchema,
  FindScheduleRequestSchema,
  FindScheduleResponseSchema,
  GetAvailableTimeSlotsRequestSchema,
  GetAvailableTimeSlotsResponseSchema,
} from "../schemas/schedule/index";
import {
  ExternalAPIErrorSchema,
  NotFoundErrorSchema,
  ConsultTimesNotFoundErrorSchema,
} from "../errors";

/**
 * Read-only vendor schedule operations available to kiosk transports.
 * Schedule writes must use authorized FrontDesk domain operations.
 *
 * @since 1.1.8
 * @example
 * ```ts
 * ScheduleRpcs.requests.has("ScheduleList");
 * ```
 */
export class ScheduleRpcs extends RpcGroup.make(
  Rpc.make("ScheduleList", {
    success: ListSchedulesResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: ListSchedulesRequestSchema,
  }),
  Rpc.make("ScheduleFind", {
    success: FindScheduleResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: FindScheduleRequestSchema,
  }),
  Rpc.make("ScheduleGetAvailableTimeSlots", {
    success: GetAvailableTimeSlotsResponseSchema,
    error: Schema.Union(
      [ExternalAPIErrorSchema,
      NotFoundErrorSchema,
      ConsultTimesNotFoundErrorSchema]
    ),
    payload: GetAvailableTimeSlotsRequestSchema,
  })
) {}
